var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplateIconStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 28,
    width: 16,
    height: 32,
    rx: 3,
    fill: "#E0E0E0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 18,
    width: 16,
    height: 42,
    rx: 3,
    fill: "#BBBBBB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 8,
    width: 16,
    height: 52,
    rx: 3,
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateIconStock);
export default __webpack_public_path__ + "static/media/template-icon-stock.56ed3b7662ee396d0c61b5529486f7eb.svg";
export { ForwardRef as ReactComponent };